import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-fi_chevron-down',
  standalone: true,
  templateUrl: '../../assets/fi_chevron-down.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamFi_chevronDownIcon {}
